import React from "react";
import PageHeader from "../components/PageHeader";
import AboutSection from "../components/AboutSection";
import WhyChoose from "../components/WhyChoose";
import Testimonials from "../components/Testimonials";

const AboutPage = () => (
  <>
    <PageHeader title="About Us" breadcrumb="About Us" />
    <AboutSection />
    <WhyChoose />
    <Testimonials />
  </>
);

export default AboutPage;
